import './../css/Footer.css';

const Footer = () => {
    return (
        <div id="footer">
            <p>@machine8822</p>
        </div>
    );
};

export default Footer;